var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart"}},[_c('apexchart',_vm._b({attrs:{"type":"donut"}},'apexchart',{ height: _vm.height, options: _vm.options, series: _vm.series },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }